import { Button, Link as B2BLink, Stack, Typography } from '@evaneos/b2b-ui';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { Query } from '../../design-system/types';
import s from '../../shared/components/layout/ContextualNavbar.css';
import { displayFilters } from '../../resources/filters';
import { useTrackEventAmplitude } from '../../shared/analytics';
import { useAppDispatch } from '../../shared/redux';
import { parseQueryString } from '../../shared/utilities/queryString';
import { NavigationToggle } from '../../shared/components/NavigationToggle';
import { useGetInboxCount } from '../../resources/inbox/hooks';
import { useHasDossiers } from '../../resources/dossier-overview/hooks';

export const HomepageNavbar = (): JSX.Element => {
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { trackEvent } = useTrackEventAmplitude();

    const query = parseQueryString(location.search) as Query;
    const hasDossiers = useHasDossiers();
    const inboxCount = useGetInboxCount(query);

    const handleFilterButtonClicked = () => {
        dispatch(displayFilters());
        trackEvent((ampli, defaultProperties) => {
            ampli.rmFilterClicked({ ...defaultProperties, category: 'inbox' });
        });
    };

    return (
        <nav className={s.navbarContainer}>
            <div className={s.pageSwitch}>
                <NavigationToggle selected="inbox" inboxCount={inboxCount} />
            </div>
            <Stack direction="row" gap={2} alignItems="center">
                <Typography variant="body1">
                    <B2BLink data-testid={'cta-agency-capacity'} href="/agency-manager/capacity">
                        Agency capacity
                    </B2BLink>
                </Typography>

                <Button
                    data-testid="process-navbar-filter-button"
                    disabled={!hasDossiers}
                    variant="outlined"
                    onClick={handleFilterButtonClicked}
                >
                    <FormattedMessage id="processes.filters.filters" />
                </Button>
            </Stack>
        </nav>
    );
};
